import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon } from 'mdbreact';
import {  MDBTabPane, MDBTabContent, MDBNav, MDBNavItem, MDBNavLink } from "mdbreact";
import Axios from 'axios'
import { Steps, Alert  } from 'antd';

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalarticletyps from './Modalarticletypes';
import Modalarticleexpert from './Modalarticleexpert';
import Modalsenteditforadmin from './Modalsenteditforadmin';




export default class superadminstatus extends Component {

    constructor(props) {
        super(props);
        this.state = {
          articlesci1:[],
          articlehum1:[],
          articlesci2:[],
          articlehum2:[],

          articlefaculty1:[],
          articlefaculty2:[],
          articlefaculty3:[],
          articlefaculty4:[],
          articlefaculty5:[],
          articlefaculty6:[],
          articlefaculty7:[],
            article2:[],
            activeItem: "1"
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
          this.selectat = this.selectat.bind(this);
      }


      toggle = tab => e => {
        if (this.state.activeItem !== tab) {
          this.setState({
            activeItem: tab
          });
        }
      };


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           //ภายใน
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty1.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlefaculty1: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty2.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlefaculty2: res.data})
           }) 

           //ภายนอก
           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty3.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlefaculty3: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty4.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlefaculty4: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty5.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlefaculty5: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty6.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlefaculty6: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty7.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlefaculty7: res.data})
           }) 
         }, 0);


      }



      selectat() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           //ภายใน
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty1.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlefaculty1: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty2.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlefaculty2: res.data})
           }) 

           //ภายนอก
           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty3.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlefaculty3: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty4.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlefaculty4: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty5.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlefaculty5: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty6.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlefaculty6: res.data})
           }) 

           Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty7.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlefaculty7: res.data})
           }) 
         }, 0);


      }


      updateat(){
        setTimeout(() => {
           
          Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticle1.php')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 

         Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticle2.php')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article2: res.data})
         }) 


       }, 0);
      }



    render() {
        const { Step } = Steps;
        return (
            <MDBContainer  fluid>
            <div>
            <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')}</p>
            <p className="text-right">การประชุมวิชาการ มหาวิทยาลัยราชภัฏกำแพงเพชร(ผู้ดูแลระบบกลาง)</p> 
         
               <MDBAlert color="info" >
                <h2><MDBIcon icon="address-card" /> สถานะบทความ (แยกคณะ)</h2>
                </MDBAlert>

                <MDBNav className="nav-tabs mt-5">
          <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === "1"} onClick={this.toggle("1")} role="tab" >
            คณะครุศาสตร์
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === "2"} onClick={this.toggle("2")} role="tab" >
            คณะวิทยาศาสตร์และเทคโนโลยี
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === "3"} onClick={this.toggle("3")} role="tab" >
            คณะมนุษยศาสตร์และสังคมศาสตร์
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === "4"} onClick={this.toggle("4")} role="tab" >
            คณะวิทยาการจัดการ
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === "5"} onClick={this.toggle("5")} role="tab" >
            คณะเทคโนโลยีอุตสาหกรรม
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === "6"} onClick={this.toggle("6")} role="tab" >
            คณะพยาบาลศาสตร์
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === "7"} onClick={this.toggle("7")} role="tab" >
            มรภ.กพ แม่สอด
            </MDBNavLink>
          </MDBNavItem>
          {/* <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === "3"} onClick={this.toggle("3")} role="tab" >
              Profile
            </MDBNavLink>
          </MDBNavItem> */}
        </MDBNav>

        <MDBTabContent activeItem={this.state.activeItem} >
          <MDBTabPane tabId="1" role="tabpanel">
            <br/>
        <Alert message={"บทความคณะครุศาสตร์ จำนวน "+ this.state.articlefaculty1.length+" บทความ"} type="info" />
          <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlefaculty1.map((articlefaculty1,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlefaculty1.send_name}<br/><hr/>
                        <Steps current={articlefaculty1.stapat}>
                            <Step title="ส่งคณะ" description={articlefaculty1.date_stap1} />
                            <Step title="คณะส่งผู้ทรง" subTitle="" description={articlefaculty1.date_stap2} />
                            <Step title="ผู้ทรงส่งกลับ" description={articlefaculty1.date_stap3} />
                            <Step title="ส่งปรับแก้" description={articlefaculty1.date_stap4}/>
                            <Step title="แก้ไขเรียบร้อย" description={articlefaculty1.send_date2} />
                            <Step title={articlefaculty1.stapat == 7  ? <>ไม่ผ่าน</>:<>ผ่าน</>} description={articlefaculty1.date_stap6} />
                        </Steps>
                        
                        </td>
                        <td>{articlefaculty1.register_pname}{articlefaculty1.register_nameth}  {articlefaculty1.register_lnameth}</td>
                        <td>{articlefaculty1.major_precent}</td>
                        <td> { articlefaculty1.stapat <= 2 ? <><MDBBtn color="indigo" size="sm" href={articlefaculty1.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlefaculty1.send_uploadepdf1}  target="_blank">PDF</MDBBtn></> : <></>} 
                        { articlefaculty1.stapat >= 3 ? <> <MDBBtn color="pink" size="sm" href={articlefaculty1.send_filecommect1}  target="_blank">ข้อเสนอแนะ</MDBBtn></> : <></>}
                        </td>
                        <td> <Modalarticletyps  id_send={articlefaculty1.id_send} namearticla={articlefaculty1.send_name}  updateat={this.updateat} />
                        {articlefaculty1.stapat == 1 ? <> < Modalarticleexpert id_send={articlefaculty1.id_send} namearticla={articlefaculty1.send_name}  selectat={this.selectat} /> </> : <> </> }
                        {articlefaculty1.stapat == 3 ? <> < Modalsenteditforadmin id_send={articlefaculty1.id_send} namearticla={articlefaculty1.send_name}  selectat={this.selectat} /> </> :<></>}
                        {articlefaculty1.url_receipt === "" || articlefaculty1.url_receipt === null?<>
                        <MDBBtn color="warning">
                          รอชำระ
                        </MDBBtn>
                        </>:<>
                        <MDBBtn href={articlefaculty1.url_receipt} target="_blank" color="primary">
                          พิมพ์ใบเสร็จ
                        </MDBBtn>
                        </>}
                       
                        </td>
                     
                        
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>
          </MDBTabPane>



          <MDBTabPane tabId="2" role="tabpanel">
              <br/>
          <Alert message={"บทความคณะวิทยาศาสตร์และเทคโนโลยี จำนวน "+ this.state.articlefaculty2.length+" บทความ"} type="info" />
          <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlefaculty2.map((articlefaculty2,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlefaculty2.send_name}<br/><hr/>
                        <Steps current={articlefaculty2.stapat}>
                            <Step title="ส่งคณะ" description={articlefaculty2.date_stap1} />
                            <Step title="คณะส่งผู้ทรง" subTitle="" description={articlefaculty2.date_stap2} />
                            <Step title="ผู้ทรงส่งกลับ" description={articlefaculty2.date_stap3} />
                            <Step title="ส่งปรับแก้" description={articlefaculty2.date_stap4}/>
                            <Step title="แก้ไขเรียบร้อย" description={articlefaculty2.send_date2} />
                            <Step title={articlefaculty2.stapat == 7  ? <>ไม่ผ่าน</>:<>ผ่าน</>} description={articlefaculty2.date_stap6} />
                        </Steps>
                        </td>
                        <td>{articlefaculty2.register_pname}{articlefaculty2.register_nameth}  {articlefaculty2.register_lnameth}</td>
                        <td>{articlefaculty2.major_precent}</td>
                        <td> { articlefaculty2.stapat <= 2 ? <><MDBBtn color="indigo" size="sm" href={articlefaculty2.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlefaculty2.send_uploadepdf1}  target="_blank">PDF</MDBBtn></> : <></>} 
                        { articlefaculty2.stapat >= 3 ? <> <MDBBtn color="pink" size="sm" href={articlefaculty2.send_filecommect1}  target="_blank">ข้อเสนอแนะ</MDBBtn></> : <></>}
                        </td>
                        <td> <Modalarticletyps  id_send={articlefaculty2.id_send} namearticla={articlefaculty2.send_name}  updateat={this.updateat} />
                        {articlefaculty2.stapat == 1 ? <> < Modalarticleexpert id_send={articlefaculty2.id_send} namearticla={articlefaculty2.send_name}  selectat={this.selectat} /> </> : <> </> }
                        {articlefaculty2.stapat == 3 ? <> < Modalsenteditforadmin id_send={articlefaculty2.id_send} namearticla={articlefaculty2.send_name}  selectat={this.selectat} /> </> :<></>}
                        {articlefaculty2.url_receipt === "" || articlefaculty2.url_receipt === null?<>
                        <MDBBtn color="warning">
                          รอชำระ
                        </MDBBtn>
                        </>:<>
                        <MDBBtn href={articlefaculty2.url_receipt} target="_blank" color="primary">
                          พิมพ์ใบเสร็จ
                        </MDBBtn>
                        </>}
                        </td>
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>
          </MDBTabPane>


          <MDBTabPane tabId="3" role="tabpanel">
              <br/>
          <Alert message={"บทความคณะมนุษยศาสตร์และสังคมศาสตร์ จำนวน "+ this.state.articlefaculty3.length+" บทความ"} type="info" />
          <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlefaculty3.map((articlefaculty3,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlefaculty3.send_name}<br/><hr/>
                        <Steps current={articlefaculty3.stapat}>
                            <Step title="ส่งคณะ" description={articlefaculty3.date_stap1} />
                            <Step title="คณะส่งผู้ทรง" subTitle="" description={articlefaculty3.date_stap2} />
                            <Step title="ผู้ทรงส่งกลับ" description={articlefaculty3.date_stap3} />
                            <Step title="ส่งปรับแก้" description={articlefaculty3.date_stap4}/>
                            <Step title="แก้ไขเรียบร้อย" description={articlefaculty3.send_date2} />
                            <Step title={articlefaculty3.stapat == 7  ? <>ไม่ผ่าน</>:<>ผ่าน</>} description={articlefaculty3.date_stap6} />
                        </Steps>
                        </td>
                        <td>{articlefaculty3.register_pname}{articlefaculty3.register_nameth}  {articlefaculty3.register_lnameth}</td>
                        <td>{articlefaculty3.major_precent}</td>

                        <td> { articlefaculty3.stapat <= 2 ? <><MDBBtn color="indigo" size="sm" href={articlefaculty3.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlefaculty3.send_uploadepdf1}  target="_blank">PDF</MDBBtn></> : <></>} 
                        { articlefaculty3.stapat >= 3 ? <> <MDBBtn color="pink" size="sm" href={articlefaculty3.send_filecommect1}  target="_blank">ข้อเสนอแนะ</MDBBtn></> : <></>}
                        </td>
                        <td> <Modalarticletyps  id_send={articlefaculty3.id_send} namearticla={articlefaculty3.send_name}  updateat={this.updateat} />
                        {articlefaculty3.stapat == 1 ? <> < Modalarticleexpert id_send={articlefaculty3.id_send} namearticla={articlefaculty3.send_name}  selectat={this.selectat} /> </> : <> </> }
                        {articlefaculty3.stapat == 3 ? <> < Modalsenteditforadmin id_send={articlefaculty3.id_send} namearticla={articlefaculty3.send_name}  selectat={this.selectat} /> </> :<></>}
                        {articlefaculty3.url_receipt === "" || articlefaculty3.url_receipt === null?<>
                        <MDBBtn color="warning">
                          รอชำระ
                        </MDBBtn>
                        </>:<>
                        <MDBBtn href={articlefaculty3.url_receipt} target="_blank" color="primary">
                          พิมพ์ใบเสร็จ
                        </MDBBtn>
                        </>}
                        </td>
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>
          </MDBTabPane>


          <MDBTabPane tabId="4" role="tabpanel">
              <br/>
          <Alert message={"บทความคณะวิทยาการจัดการ จำนวน "+ this.state.articlefaculty4.length+" บทความ"} type="info" />
          <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlefaculty4.map((articlefaculty4,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlefaculty4.send_name}<br/><hr/>
                        <Steps current={articlefaculty4.stapat}>
                            <Step title="ส่งคณะ" description={articlefaculty4.date_stap1} />
                            <Step title="คณะส่งผู้ทรง" subTitle="" description={articlefaculty4.date_stap2} />
                            <Step title="ผู้ทรงส่งกลับ" description={articlefaculty4.date_stap3} />
                            <Step title="ส่งปรับแก้" description={articlefaculty4.date_stap4}/>
                            <Step title="แก้ไขเรียบร้อย" description={articlefaculty4.send_date2} />
                            <Step title={articlefaculty4.stapat == 7  ? <>ไม่ผ่าน</>:<>ผ่าน</>} description={articlefaculty4.date_stap6} />
                        </Steps>
                        </td>
                        <td>{articlefaculty4.register_pname}{articlefaculty4.register_nameth}  {articlefaculty4.register_lnameth}</td>
                        <td>{articlefaculty4.major_precent}</td>
                       
                        <td> { articlefaculty4.stapat <= 2 ? <><MDBBtn color="indigo" size="sm" href={articlefaculty4.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlefaculty4.send_uploadepdf1}  target="_blank">PDF</MDBBtn></> : <></>} 
                        { articlefaculty4.stapat >= 3 ? <> <MDBBtn color="pink" size="sm" href={articlefaculty4.send_filecommect1}  target="_blank">ข้อเสนอแนะ</MDBBtn></> : <></>}
                        </td>
                        <td> <Modalarticletyps  id_send={articlefaculty4.id_send} namearticla={articlefaculty4.send_name}  updateat={this.updateat} />
                        {articlefaculty4.stapat == 1 ? <> < Modalarticleexpert id_send={articlefaculty4.id_send} namearticla={articlefaculty4.send_name}  selectat={this.selectat} /> </> : <> </> }
                        {articlefaculty4.stapat == 3 ? <> < Modalsenteditforadmin id_send={articlefaculty4.id_send} namearticla={articlefaculty4.send_name}  selectat={this.selectat} /> </> :<></>}
                        {articlefaculty4.url_receipt === "" || articlefaculty4.url_receipt === null?<>
                        <MDBBtn color="warning">
                          รอชำระ
                        </MDBBtn>
                        </>:<>
                        <MDBBtn href={articlefaculty4.url_receipt} target="_blank" color="primary">
                          พิมพ์ใบเสร็จ
                        </MDBBtn>
                        </>}
                        </td>
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>
          </MDBTabPane>

          <MDBTabPane tabId="5" role="tabpanel">
              <br/>
          <Alert message={"บทความคณะเทคโนโลยีอุตสาหกรรม จำนวน "+ this.state.articlefaculty5.length+" บทความ"} type="info" />
          <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlefaculty5.map((articlefaculty5,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlefaculty5.send_name}<br/><hr/>
                        <Steps current={articlefaculty5.stapat}>
                            <Step title="ส่งคณะ" description={articlefaculty5.date_stap1} />
                            <Step title="คณะส่งผู้ทรง" subTitle="" description={articlefaculty5.date_stap2} />
                            <Step title="ผู้ทรงส่งกลับ" description={articlefaculty5.date_stap3} />
                            <Step title="ส่งปรับแก้" description={articlefaculty5.date_stap4}/>
                            <Step title="แก้ไขเรียบร้อย" description={articlefaculty5.send_date2} />
                            <Step title={articlefaculty5.stapat == 7  ? <>ไม่ผ่าน</>:<>ผ่าน</>} description={articlefaculty5.date_stap6} />
                        </Steps>
                        </td>
                        <td>{articlefaculty5.register_pname}{articlefaculty5.register_nameth}  {articlefaculty5.register_lnameth}</td>
                        <td>{articlefaculty5.major_precent}</td>

                        <td> { articlefaculty5.stapat <= 2 ? <><MDBBtn color="indigo" size="sm" href={articlefaculty5.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlefaculty5.send_uploadepdf1}  target="_blank">PDF</MDBBtn></> : <></>} 
                        { articlefaculty5.stapat >= 3 ? <> <MDBBtn color="pink" size="sm" href={articlefaculty5.send_filecommect1}  target="_blank">ข้อเสนอแนะ</MDBBtn></> : <></>}
                        </td>
                        <td> <Modalarticletyps  id_send={articlefaculty5.id_send} namearticla={articlefaculty5.send_name}  updateat={this.updateat} />
                        {articlefaculty5.stapat == 1 ? <> < Modalarticleexpert id_send={articlefaculty5.id_send} namearticla={articlefaculty5.send_name}  selectat={this.selectat} /> </> : <> </> }
                        {articlefaculty5.stapat == 3 ? <> < Modalsenteditforadmin id_send={articlefaculty5.id_send} namearticla={articlefaculty5.send_name}  selectat={this.selectat} /> </> :<></>}
                        {articlefaculty5.url_receipt === "" || articlefaculty5.url_receipt === null?<>
                        <MDBBtn color="warning">
                          รอชำระ
                        </MDBBtn>
                        </>:<>
                        <MDBBtn href={articlefaculty5.url_receipt} target="_blank" color="primary">
                          พิมพ์ใบเสร็จ
                        </MDBBtn>
                        </>}
                        </td>
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>
          </MDBTabPane>


          <MDBTabPane tabId="6" role="tabpanel">
              <br/>
          <Alert message={"บทความคณะพยาบาลศาสตร์ จำนวน "+ this.state.articlefaculty6.length+" บทความ"} type="info" />
          <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlefaculty6.map((articlefaculty6,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlefaculty6.send_name}<br/><hr/>
                        <Steps current={articlefaculty6.stapat}>
                            <Step title="ส่งคณะ" description={articlefaculty6.date_stap1} />
                            <Step title="คณะส่งผู้ทรง" subTitle="" description={articlefaculty6.date_stap2} />
                            <Step title="ผู้ทรงส่งกลับ" description={articlefaculty6.date_stap3} />
                            <Step title="ส่งปรับแก้" description={articlefaculty6.date_stap4}/>
                            <Step title="แก้ไขเรียบร้อย" description={articlefaculty6.send_date2} />
                            <Step title={articlefaculty6.stapat == 7  ? <>ไม่ผ่าน</>:<>ผ่าน</>} description={articlefaculty6.date_stap6} />
                        </Steps>
                        </td>
                        <td>{articlefaculty6.register_pname}{articlefaculty6.register_nameth}  {articlefaculty6.register_lnameth}</td>
                        <td>{articlefaculty6.major_precent}</td>

                        <td> { articlefaculty6.stapat <= 2 ? <><MDBBtn color="indigo" size="sm" href={articlefaculty6.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlefaculty6.send_uploadepdf1}  target="_blank">PDF</MDBBtn></> : <></>} 
                        { articlefaculty6.stapat >= 3 ? <> <MDBBtn color="pink" size="sm" href={articlefaculty6.send_filecommect1}  target="_blank">ข้อเสนอแนะ</MDBBtn></> : <></>}
                        </td>
                        <td> <Modalarticletyps  id_send={articlefaculty6.id_send} namearticla={articlefaculty6.send_name}  updateat={this.updateat} />
                        {articlefaculty6.stapat == 1 ? <> < Modalarticleexpert id_send={articlefaculty6.id_send} namearticla={articlefaculty6.send_name}  selectat={this.selectat} /> </> : <> </> }
                        {articlefaculty6.stapat == 3 ? <> < Modalsenteditforadmin id_send={articlefaculty6.id_send} namearticla={articlefaculty6.send_name}  selectat={this.selectat} /> </> :<></>}
                        {articlefaculty6.url_receipt === "" || articlefaculty6.url_receipt === null?<>
                        <MDBBtn color="warning">
                          รอชำระ
                        </MDBBtn>
                        </>:<>
                        <MDBBtn href={articlefaculty6.url_receipt} target="_blank" color="primary">
                          พิมพ์ใบเสร็จ
                        </MDBBtn>
                        </>}
                        </td>
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>
          </MDBTabPane>


          <MDBTabPane tabId="7" role="tabpanel">
              <br/>
          <Alert message={"บทความมรภ.กพ แม่สอด จำนวน "+ this.state.articlefaculty7.length+" บทความ"} type="info" />
          <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlefaculty7.map((articlefaculty7,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlefaculty7.send_name}<br/><hr/>
                        <Steps current={articlefaculty7.stapat}>
                            <Step title="ส่งคณะ" description={articlefaculty7.date_stap1} />
                            <Step title="คณะส่งผู้ทรง" subTitle="" description={articlefaculty7.date_stap2} />
                            <Step title="ผู้ทรงส่งกลับ" description={articlefaculty7.date_stap3} />
                            <Step title="ส่งปรับแก้" description={articlefaculty7.date_stap4}/>
                            <Step title="แก้ไขเรียบร้อย" description={articlefaculty7.send_date2} />
                            <Step title={articlefaculty7.stapat == 7  ? <>ไม่ผ่าน</>:<>ผ่าน</>} description={articlefaculty7.date_stap6} />
                        </Steps>
                        </td>
                        <td>{articlefaculty7.register_pname}{articlefaculty7.register_nameth}  {articlefaculty7.register_lnameth}</td>
                        <td>{articlefaculty7.major_precent}</td>
                        <td><MDBBtn color="indigo" size="sm" href={articlefaculty7.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlefaculty7.send_uploadepdf1}  target="_blank">PDF</MDBBtn></td>
                        <td>   <Modalarticletyps  id_send={articlefaculty7.id_send} namearticla={articlefaculty7.send_name}  updateat={this.updateat} />
                        {articlefaculty7.url_receipt === "" || articlefaculty7.url_receipt === null?<>
                        <MDBBtn color="warning">
                          รอชำระ
                        </MDBBtn>
                        </>:<>
                        <MDBBtn href={articlefaculty7.url_receipt} target="_blank" color="primary">
                          พิมพ์ใบเสร็จ
                        </MDBBtn>
                        </>}
                       </td>
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>
          </MDBTabPane>




         
        </MDBTabContent>





            </div>
            </MDBContainer>
        )
    }
}
